import { replaceVtexSrcImageSize } from '~/helpers/image.helper'
import { cn } from '~/lib/cn'

export type CartListItemImageProps = {
  src: string
  alt: string
  title?: string
  href?: string
  className?: string
}

const DEFAULT_WIDTH = 48
const DEFAULT_HEIGHT = 48

export default function CartListItemImage({ href, src, alt, title, className = '' }: CartListItemImageProps) {
  const srcLarge = replaceVtexSrcImageSize(src, DEFAULT_WIDTH * 3, DEFAULT_HEIGHT * 3)
  const srcMedium = replaceVtexSrcImageSize(src, DEFAULT_WIDTH * 2, DEFAULT_HEIGHT * 2)
  return (
    <a
      aria-label={`Ver detalhes do produto: ${title || alt}`}
      className={cn(className, 'rounded overflow-hidden border hover:border-orange-300')}
      data-comp="CartListItemImage"
      href={href}
      tabIndex={-1}
    >
      <img
        alt={alt}
        height={DEFAULT_HEIGHT}
        loading="lazy"
        sizes="(min-width: 640px) 50vw, 100vw"
        src={srcLarge}
        srcSet={`${srcMedium} 640w, ${srcLarge} 1024w`}
        width={DEFAULT_WIDTH}
      />
    </a>
  )
}
